import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback } from "../ui/avatar";
import { Creator } from "@/types/tutorial";

interface TutorialOverviewHeaderProps {
  title: string;
  description: string;
  creator?: Creator;
  muted?: boolean;
}

export function TutorialOverviewHeader({
  title,
  description,
  creator,
  muted = false,
}: TutorialOverviewHeaderProps) {
  return (
    <div
      className={cn("flex gap-4", {
        "hover:cursor-not-allowed": muted,
      })}
    >
      <Avatar className="h-12 w-12 border mt-1">
        <AvatarFallback className="bg-gradient-to-r from-primary to-accent text-primary-foreground text-sm">
          {(creator?.name ?? "Anonymous").charAt(0)}
        </AvatarFallback>
      </Avatar>

      <div
        className={cn("flex-1 min-w-0", {
          "cursor-pointer": !muted,
          "cursor-not-allowed": muted,
        })}
      >
        <h3 className="text-lg font-semibold text-foreground mb-1">{title}</h3>
        <p className="text-sm text-foreground/90 line-clamp-2 hidden md:block">
          {description}
        </p>
      </div>
    </div>
  );
}
